import { VendorDetailsInterface } from 'features/Enterprise/Vendor/types/VendorManagement'

type ShippingLocationType = VendorDetailsInterface['shipping_information'][0]['locations'][0]

const resolveLocationId = (location: ShippingLocationType): number => {
  if (typeof location === 'number') return location
  return location.location_id ?? 0
}

export const toSubmissionShippingFromVendorDetails = (
  shippingInformation: VendorDetailsInterface['shipping_information'] | undefined,
) =>
  (shippingInformation ?? []).map((shipping) => ({
    ...shipping,
    locations: (shipping.locations ?? []).map(resolveLocationId).filter((id) => id > 0),
  }))
